<template>
  <Dialog
    v-model:visible="visibleLocal"
    modal
    :header="t('environment.warning.title')"
    :style="{ width: '500px' }"
    :closable="false"
    :dismissableMask="false"
    class="environment-warning-dialog"
  >
    <div class="flex flex-col gap-4">
      <div class="flex items-start gap-3">
        <i class="pi pi-exclamation-triangle text-red-500 text-2xl"></i>
        <p class="text-sm text-color-secondary m-0">
          {{ t('environment.warning.message') }}
        </p>
      </div>

      <div class="flex items-center gap-2">
        <Checkbox
          v-model="rememberChoice"
          inputId="remember-choice"
          :binary="true"
        />
        <label for="remember-choice" class="text-sm cursor-pointer">
          {{ t('environment.warning.remember_choice') }}
        </label>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-2">
        <Button
          :label="t('environment.warning.continue_here')"
          severity="secondary"
          text
          @click="onContinue"
        />
        <Button
          :label="t('environment.warning.go_to_production')"
          severity="danger"
          @click="onRedirect"
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  visible: boolean
}>()

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void
  (e: 'redirect'): void
  (e: 'continue'): void
}>()

const { t } = useI18n()

const visibleLocal = ref(props.visible)
const rememberChoice = ref(false)

const STORAGE_KEY = 'env_warning_choice'

watch(() => props.visible, (val) => {
  visibleLocal.value = val
})

watch(visibleLocal, (val) => {
  emit('update:visible', val)
})

function onRedirect() {
  if (rememberChoice.value) {
    localStorage.setItem(STORAGE_KEY, 'redirect')
  }
  emit('redirect')
}

function onContinue() {
  if (rememberChoice.value) {
    localStorage.setItem(STORAGE_KEY, 'continue')
  }
  emit('continue')
  visibleLocal.value = false
}
</script>

<style scoped>
:deep(.environment-warning-dialog .p-dialog-header) {
  background-color: var(--p-red-500) !important;
  color: white !important;
}

:deep(.environment-warning-dialog .p-dialog-header .p-dialog-title) {
  color: white !important;
}
</style>

